import React, { useState } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { CdnForm } from './CdnForm';
import { CdnList } from './CdnList';

export const CustomComponentCDNs = ({
  projectId,
  version,
  validateUrl,
  title,
  cdns,
  customComponentId,
  onSubmit,
  onDelete,
  onUpdate,
}) => {
  const [toggle, setToggle] = useState(false);
  const [currentCdn, setCurrentCdn] = useState('');

  return (
    <ParentCardNoCol
      title={title}
      bgColor="drapcode-violet"
      icon="customJSCDN"
      CtaComponent={
        <button
          type="button"
          className="btn btn-theme-submit btn-md"
          onClick={() => {
            setCurrentCdn('');
            setToggle(true);
          }}
        >
          <i className={`wb ${drapcodeIcon('add')}`}></i> {title}&nbsp;
        </button>
      }
    >
      {toggle && (
        <CdnForm
          title={title}
          currentCdn={currentCdn}
          customComponentId={customComponentId}
          projectId={projectId}
          version={version}
          validateUrl={validateUrl}
          onSubmit={onSubmit}
          onUpdate={onUpdate}
          setToggle={setToggle}
        />
      )}
      {cdns && cdns.length > 0 && (
        <CdnList
          projectId={projectId}
          version={version}
          customComponentId={customComponentId}
          cdns={cdns}
          setCurrentCdn={setCurrentCdn}
          setToggle={setToggle}
          onDelete={onDelete}
        />
      )}
    </ParentCardNoCol>
  );
};
